/* rv-rivo.js — returning-visitor homepage, v2 (2026-10-07). Spec + acceptance test:
 * Claude/planning/rv-homepage-state-matrix-2026-10-06.md
 *
 * LAYOUT IS NOT DECIDED HERE. rv-variant-gate sets every attribute the layout depends on
 * (data-rv-variant, data-rv-state = A|B|M, data-rv-hist, data-rv-orders) synchronously,
 * before first paint, and this file never changes them. All it does is fetch the member's
 * Rivo numbers and hand them to the card and the club, which fill IN PLACE.
 *
 * Published state (window.RV.state):
 *   code "A" | "B"      not a member — nothing to fetch
 *   code "C"            member, Rivo not answered (yet, or ever): name only
 *   code "D"            member, Rivo answered: points, tier, spend, rewards
 *
 * Live Rivo field names (read off a signed-in DK session 2026-10-05, not off the bundle):
 *   RivoJS.getCustomerDetails() -> points_tally, completed_custom_action_names, completed_actions
 *   RivoJS.getCustomerVipTier() -> tier.name, current_period_spend, next_tier.{name,threshold,to_spend_or_earn}, highest_tier
 * Preview only (needs ?rv=): ?rv=d [&rv_pts=N] forces a member with sample numbers from the
 * LIVE programme; ?rv=c forces "Rivo did not answer". No production path reads these.
 */
(function () {
  "use strict";
  if (window.RV) return;
  var el = document.querySelector("[data-rv-config]");
  var CFG = {}; try { CFG = JSON.parse(el ? el.textContent : "{}"); } catch (e) {}
  var html = document.documentElement;
  var listeners = [], current = null;

  function qs(k) { var m = new RegExp("[?&]" + k + "=([^&]*)").exec(location.search); return m ? decodeURIComponent(m[1]).toLowerCase() : null; }
  function num(v) { var n = Number(v); return v !== null && v !== "" && isFinite(n) ? n : null; }

  /* first-seen stamp for the NEXT visit's "returning" test (the gate reads it). Consent-gated. */
  try {
    var canTrack = !(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.userCanBeTracked) || Shopify.customerPrivacy.userCanBeTracked();
    if (canTrack && !localStorage.getItem("ob_first_seen")) localStorage.setItem("ob_first_seen", String(Date.now()));
  } catch (e) {}

  function programme() {
    var c = (window.Rivo && window.Rivo.loy_config) || null;
    if (!c) return CFG.programme_fallback || null;   // DEV / Rivo absent
    var tiers = (c.vip_tiers || []).map(function (t) {
      var r = (t.rewards || [])[0] || null;
      return {
        id: t.id,
        name: t.name,
        threshold: Number(t.threshold) || 0,
        perk: r ? {
          name: r.name,
          type: r.reward_type,
          value: r.reward_value,
          min_cents: r.min_order_value_in_cents,
          product_title: r.product_title || null
        } : null
      };
    }).sort(function (a, b) { return a.threshold - b.threshold; });
    var ladder = (c.rewards || []).map(function (r) {
      return {
        name: r.name,
        points: Number(r.points_amount) || 0,
        value: Number(r.reward_value) || 0,
        type: r.reward_type,
        min_cents: Number(r.min_order_value_in_cents) || 0
      };
    }).sort(function (a, b) { return a.points - b.points; });
    var earn = (c.ways_to_earn || []).map(function (w) {
      var tiers = {};
      Object.keys(w.multi_balance_settings_by_tiers || {}).forEach(function (k) {
        var n = Number((w.multi_balance_settings_by_tiers[k] || {}).balance_amount); if (isFinite(n)) tiers[k] = n;
      });
      return { title: (w.title || w.name || "").trim(), trigger: w.trigger || "", points: Number(w.points || w.points_amount) || 0, tiers: tiers };
    });
    /* what the referred FRIEND gets — the earn tile states it ("they get €15 off") and it
       must come from the programme, not from a string in the theme */
    var rr = c.referral_rewards;
    var ref = Array.isArray(rr) ? rr[0]
            : (rr && (rr.referred_reward || rr.friend_reward))            /* DK ships an object */
            || (c.referral_settings || {}).friend_reward || null;
    var refVal = ref ? Number(ref.reward_value != null ? ref.reward_value : ref.value) : null;
    return { tiers: tiers, ladder: ladder, earn: earn,
             referral_friend_value: isFinite(refVal) ? refVal : null,
             currency: c.base_money_format || null };
  }


  function derive(p, points, spend, tierName) {
    var out = { points: points, spend: spend, tier: tierName || null, tier_obj: null, next_tier: null, to_next: null, reward_ready: null, next_reward: null };
    if (!p) return out;
    var tiers = p.tiers || [], i;
    for (i = 0; i < tiers.length; i++) if (tierName ? tiers[i].name === tierName : spend >= tiers[i].threshold) out.tier_obj = tiers[i];
    if (!out.tier && out.tier_obj) out.tier = out.tier_obj.name;
    var curT = out.tier_obj ? out.tier_obj.threshold : 0;
    for (i = 0; i < tiers.length; i++) if (tiers[i].threshold > curT) { out.next_tier = tiers[i]; out.to_next = Math.max(0, tiers[i].threshold - spend); break; }
    var ladder = p.ladder || [];
    for (i = 0; i < ladder.length; i++) { if (points >= ladder[i].points) out.reward_ready = ladder[i]; else { out.next_reward = ladder[i]; break; } }
    return out;
  }

  /* the shop's own money format ("269 DKK"), whole units like every price on the site */
  function money(v) {
    if (v == null) return "";
    var n = Math.round(Number(v));
    var fmt = CFG.money_format || "{{amount_no_decimals}} " + (CFG.currency || "");
    var thou = function (x, sep) { return String(x).replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (/comma_separator/.test(k)) return thou(n, ".");
      return thou(n, ",");
    }).replace(/<[^>]*>/g, "").trim();
  }

  function emit(st) {
    current = st;
    listeners.forEach(function (fn) { try { fn(st); } catch (e) {} });
    document.dispatchEvent(new CustomEvent("rv:state", { detail: st }));
  }

  function waitForRivo(ms) {
    return new Promise(function (res, rej) {
      var t0 = Date.now();
      (function tick() {
        if (window.RivoJS && typeof window.RivoJS.getCustomerDetails === "function") return res();
        if (Date.now() - t0 > ms) return rej(new Error("rivo-absent"));
        setTimeout(tick, 60);
      })();
    });
  }

  function start() {
    var code = html.getAttribute("data-rv-state");          // set by the gate, never changed here
    var forced = qs("rv");
    var name = (CFG.customer && CFG.customer.first_name) || (forced ? "Mary" : "");
    var base = { first_name: name, orders: CFG.orders || [], money: money };
    if (code !== "M") return emit(Object.assign({ code: code || "A", programme: programme() }, base));

    // member: name now, numbers when Rivo answers (late answers still fill in — nothing moves)
    emit(Object.assign({ code: "C", programme: programme() }, base));
    if (forced === "c") return;                              // preview: Rivo never answers
    if (forced === "d") {
      var once = function () {
        var p = programme(); if (!p) return false;
        var ts = p.tiers || [], ls = p.ladder || [];
        var spend = num(qs("rv_spend")); if (spend == null) spend = ts.length > 2 ? Math.round(ts[1].threshold + (ts[2].threshold - ts[1].threshold) * 0.4) : 0;
        var pts = num(qs("rv_pts")); if (pts == null) pts = ls.length > 1 ? ls[1].points + 200 : 0;
        var st = derive(p, pts, spend, null);
        emit(Object.assign(st, { code: "D", programme: p, completed: [] }, base));
        return true;
      };
      if (!once()) waitForRivo(6000).then(once).catch(function () {});
      return;
    }
    waitForRivo(8000).then(function () {
      var vip = typeof window.RivoJS.getCustomerVipTier === "function"
        ? Promise.resolve(window.RivoJS.getCustomerVipTier()).catch(function () { return null; }) : Promise.resolve(null);
      return Promise.all([window.RivoJS.getCustomerDetails(), vip]);
    }).then(function (r) {
      var d = r[0] || {}, v = r[1] || {};
      var points = num(d.points_tally);
      if (points == null) return;                            // never render a number we invented
      var p = programme();
      var st = derive(p, points, num(v.current_period_spend) || 0, (v.tier && v.tier.name) || null);
      if (v.highest_tier) { st.next_tier = null; st.to_next = null; }
      else if (v.next_tier && num(v.next_tier.to_spend_or_earn) != null) {
        st.to_next = num(v.next_tier.to_spend_or_earn);
        st.next_tier = ((p && p.tiers) || []).filter(function (t) { return t.name === v.next_tier.name; })[0] || { name: v.next_tier.name, threshold: v.next_tier.threshold };
      }
      st.completed = (d.completed_custom_action_names || []).concat(d.completed_actions || [], d.social_actions || []);
      /* favourites band: revealed only when there is something in it (below the fold) */
      if (typeof window.RivoJS.getFavoriteProducts === "function") {
        Promise.resolve(window.RivoJS.getFavoriteProducts()).then(function (f) {
          if (f && f.products && f.products.length >= 3) html.setAttribute("data-rv-fav", "");   // 3-product floor
        }).catch(function () {});
      }
      emit(Object.assign(st, { code: "D", programme: p }, base));
    }).catch(function () {});                               // stays C: name only
  }

  window.RV = {
    onState: function (fn) { listeners.push(fn); if (current) { try { fn(current); } catch (e) {} } },
    get state() { return current; },
    money: money,
    programme: programme
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
})();
